import { ReactNode } from "react";

interface LayoutProps {
  className?: string;
  tvlDisplay: ReactNode;
  trustSignals: ReactNode;
  heading: ReactNode;
  toolbar: ReactNode;
  markets: ReactNode;
}

export function Layout({
  className,
  tvlDisplay,
  trustSignals,
  heading,
  toolbar,
  markets,
}: LayoutProps): JSX.Element {
  return (
    <div className={className}>
      <div className="inline-flex flex-col lg:flex-row items-start gap-2.5">
        <div>{tvlDisplay}</div>

        <div>{trustSignals}</div>
      </div>

      <div className="flex flex-col gap-8 mt-8 md:flex-row md:mt-10 md:items-center">
        <div className="flex items-baseline justify-between md:justify-start md:gap-6">
          {heading}
        </div>
        {toolbar}
      </div>

      <div className="mt-8 md:mt-10">{markets}</div>
    </div>
  );
}
